import { z } from 'my-zod'
import { revisionModel } from './revision-model'

export const revisionSystemView = revisionModel
  .pick({
    diff: true,
    full: true,
    lastModifiedDate: true
  })
  .augment({
    profileName: z.string().nullish(),
    profileEmail: z.string().nullish()
  })

export type revisionSystemView = z.infer<typeof revisionSystemView>
